<template>
  <div class="layout">
    <!-- 左侧菜单 -->
    <SidebarNav class="sidebar" />
    <div class="main-container">
      <!-- 顶栏 -->
      <TopAside/>
      <!-- 内容区 -->
      <Content/>
    </div>
  </div>
</template>

<script>
import SidebarNav from "./component/sidebar-nav";
import TopAside from './component/top-aside'
import Content from './component/content'
export default {
  data() {
    return {};
  },
  computed: {},
  components: {
    SidebarNav, 
    TopAside,
    Content
  },
};
</script>

<style lang="scss" scoped>
.layout {
  background: #f5f5fc;
  width: 100vw;
  height: 100vh;
  /* 主体内容 */
  .main-container {
    min-height: 100%;
    margin-left: 200px;
    transition: margin-left 0.25s;
    position: relative;
    box-sizing: border-box;
    // padding: 60px 20px 0 20px;
  }
  .sidebar {
    width: 200px !important;
    height: 100%;
    // background: #304156;
    transition: all 0.25s;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    overflow-x: hidden;
  }
}
</style>